<template>
  <div class="file-manager">
    <div class="fm-toolbar">
      <b-button @click="getTreeData()" variant="light" size="sm" class="mr-1"><i class="fas fa-sync-alt"></i> Atualizar</b-button>
      <span style="border-left:1px solid #ccc"></span>
      
      <span style="border-left:1px solid #ccc"></span>
      <b-button v-if="permitEdit" @click="showUpload()" variant="light" size="sm" class="ml-1 mr-1"><i class="fas fa-upload"></i> Upload</b-button>
      <div style="max-width:300px;float: right"><b-form-input v-model="searchFile" @change="onSearchFile" size="sm" placeholder="Procurar..." id="searchFile" trim></b-form-input></div>
      <!-- <b-button @click="downloadFolder()" variant="light" size="sm" class="float-right ml-1 mr-1"><i class="fas fa-download"></i> Download da Pasta</b-button> -->
    </div>
    <split-pane style="min-height: 200px;height:400px" :min-percent="20" :default-percent="30" split="vertical">
      <template slot="paneL">
        <Tree style="height: 368px" :data="treeData" :options="treeOptions" ref="fmTree">
          <label class="tree-text folder-label" slot-scope="{ node }">
            <template>
              <span>
                <i class="fas fa-folder"></i>
                {{ node.text }}
              </span>
            </template>
          </label>
        </Tree>
        <div class="fm-folder-bar">
          <b-button v-if="permitEdit" @click="showNewFolder()" variant="light" size="sm" class="mr-1"><i class="fas fa-folder-plus"></i> Nova</b-button>          
          <b-button v-if="permitEdit" @click="showRenameFolder()" variant="light" size="sm" class="mr-1"><i class="fas fa-folder"></i> Renomear</b-button>
          <b-button v-if="permitEdit" @click="deleteFolder()" variant="light" size="sm" class="mr-1"><i class="fas fa-folder-minus"></i> Excluir</b-button>
        </div>
      </template>
      <template slot="paneR">
          <div class="panel-files">
            <b-table
                small
                striped 
                bordered 
                responsive
                head-variant="dark"
                selectable
                sticky-header="100%"
                select-mode="single"
                selected-variant="primary"
                show-empty
                empty-text="Pasta vazia"
                :items="filesTable.files" 
                :fields="filesTable.fields" 
                :busy="filesTable.isBusy">
              <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(detalhe)="data">
                <b-row>
                  <b-col lg="6">
                    <span v-if="data.item.mes > 0 || data.item.ano > 0"><b>Mês/Ano:</b> {{ `${data.item.mes} / ${data.item.ano}` }}</span>
                  </b-col>
                  <b-col lg="6">
                    <span v-if="data.item.versao > 0"><b>Versão:</b> {{ data.item.versao }}</span>                    
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <span v-if="data.item.observacoes"><b>Observações: </b>{{ data.item.observacoes.length > 100 ? data.item.observacoes.substring(0, 100) + '...' : data.item.observacoes }}</span>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(nome_arquivo)="data">
                <a href @click.prevent="downloadFile(data.item)" >{{ data.item.nome_arquivo }}</a>
              </template>
              <template v-slot:cell(actions)="data">
                  <b-button  v-if="permitEdit" size="sm" variant="success" @click="editFile(data.item)">
                      <i class="fas fa-edit"></i>
                  </b-button>
                  <b-button  v-if="permitEdit" size="sm" variant="danger" @click="deleteFile(data.item)">
                      <i class="fas fa-trash"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="viewFile(data.item)">
                      <i class="fas fa-search"></i>
                  </b-button>
                  <b-button size="sm" variant="primary" @click="showFileHistory(data.item)">
                      <i class="fas fa-history"></i>
                  </b-button>
              </template>

            </b-table>
          </div>
      </template>
    </split-pane>
    <b-modal no-fade id="modal-new-folder" ref="modal-new-folder" title="Nova Pasta">
        <b-row>
          <b-col lg="12">
            <b-form-input v-model="newFolderName" size="sm" placeholder="Nome da Pasta" trim></b-form-input>
          </b-col>
        </b-row>
        <br/>
        <b-row>
          <b-col lg="12">
            <b-form-checkbox id="chkRaiz" v-model="newFolderRoot" :disabled="rootForced" name="chkRaiz" value="true" unchecked-value="false">
              Adicionar na Raiz
            </b-form-checkbox>        
          </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button size="sm" @click="newFolder()" variant="primary">
            <i class="fas fa-check"></i> Gravar
            </b-button>
            <b-button size="sm" @click="() => $bvModal.hide('modal-new-folder')">Cancelar</b-button>
        </template>
    </b-modal>
    <b-modal no-fade id="modal-rename-folder" ref="modal-rename-folder" title="Renomear Pasta">
        <b-row>
          <b-col lg="12">
            <b-form-input v-model="newFolderName" size="sm" placeholder="Nome da Pasta" trim></b-form-input>
          </b-col>
        </b-row>
        <br/>
        <template v-slot:modal-footer>
            <b-button size="sm" @click="renameFolder()" variant="primary">
            <i class="fas fa-check"></i> Gravar
            </b-button>
            <b-button size="sm" @click="() => $bvModal.hide('modal-rename-folder')">Cancelar</b-button>
        </template>
    </b-modal>
    <ModalUpload :folder="curFolder" @uploadComplete='loadFiles(curFolder.pasta_id)' />
    <ModalEditUpload :file="curFile" @updateComplete='loadFiles(curFolder.pasta_id)' />

    <FileHistory ref="modalHistory" :file="curFile" />
  </div>
</template>

<script>
import splitPane from "vue-splitpane"
import Tree from "liquor-tree"
import ModalUpload from "./ModalUpload"
import ModalEditUpload from "./ModalEditUpload"
import FileHistory from './FileHistory'

import { baseApiUrl, showError, formatDate } from '@/global'
import axios from 'axios'

export default {
  name: "FileManager",
  components: { splitPane, Tree, ModalUpload, ModalEditUpload, FileHistory },
  computed: {
    permitEdit: function(){
      let _perfilid = this.$store.state.user.user.perfil_id

      if(_perfilid >= 2 && (_perfilid !== 4 && _perfilid !== 5))
        return false

      return true
    }
  },
  props: { 
    projectID: {
      type: Number,
      required: true,
      default: 0
      },
    action: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      treeData: [],
      searchFile: '',
      treeOptions: {
        propertyNames: { text: "nome", data: "customData" }
      },
      newFolderName:'',
      newFolderRoot: false,
      curFile: {},
      curFolder: { 
        pasta_id: 0,
        nome: ''
      },
      rootForced: false,
      filesTable:{
        files:[],
        fields:[
            {key: 'nome_arquivo', label: 'Arquivo', sortable: true, 'class': 'font-small'},
            {key: 'dt_upload', label: 'D/H Upload', sortable: true, 'class': 'font-small w100-field', formatter: function(val){
                return formatDate(val, "YYYY-MM-DD HH:mm:ss", "DD/MM/YY HH:mm")
            }},
            {key: 'usuario.name', label: 'Usuário', sortable: true, 'class': 'font-small'},
            {key: 'detalhe', label: 'Detalhe/Observações', sortable: false, 'class': 'font-small'},
            {key: 'actions', label: 'Ações', 'class': 'font-small w120-field'},
        ],
        isBusy: false
      }
    };
  },
  methods: {
    onSearchFile(event){
      this.filesTable.files = [];
      if(this.projectID === 0)
        return

      this.filesTable.isBusy = true
      axios.get(`${baseApiUrl}/arquivos/search/${this.projectID}`, {'search': event})
        .then(
          resp => {
            this.filesTable.isBusy = false
            this.filesTable.files = resp.data
          }
        )
        .catch(ex => {
          this.filesTable.isBusy = false
          showError(ex)
        })

    },
    editFile(file){
      this.curFile = file
      this.$bvModal.show('modal-edit-upload')
    },
    deleteFile(file) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Arquivo ${file.nome_arquivo}?`, {
          noFade: true
        })
        .then(
          (yesno) => {
            
            this.isBusy = true
            if(yesno){
              axios.delete(`${baseApiUrl}/arquivos/${file.arquivo_id}`, )
                .then(
                  () =>
                  {
                    let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })                      
                    this.loadFiles(_folderSelected[0].data.pasta_id)
                  }
                )
                .catch((err) => {
                  this.isBusy = false
                  showError(err)
                })
            }
          }
        ).catch(err => {
          console.log(err);
        });
    },
    downloadFile(file){
      axios({
          url: `${baseApiUrl}/arquivos/${file.arquivo_id}`,
          method: 'GET',
          responseType: 'blob',
      }).then((response) => {
          var fileURL = window.URL.createObjectURL(response.data);
          var fileLink = document.createElement('a');
          fileLink.setAttribute('id', 'tempDownloadLinkFile');


          fileLink.href = fileURL;
          fileLink.setAttribute('download', file.nome_arquivo);
          document.body.appendChild(fileLink);
          if(file.nome_arquivo.toLowerCase().endsWith(".pdf"))
            window.open(fileURL, "_blank")
          else
            fileLink.click();
          fileLink.parentNode.removeChild(fileLink);
      });      
    },
    showUpload(){
      let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })  
      if(_folderSelected.length == 0){
        this.$toasted.info("Selecione uma pasta!", {duration: 4000, keepOnHover: true, className: 'v-toasted-warning'});
        return
      }
      this.curFolder = _folderSelected[0].data
      this.$bvModal.show('modal-upload');
    },
    showFileHistory(file){
      this.curFile = file
      this.$refs.modalHistory.getHistory()
      this.$bvModal.show('modal-history')
    },
    getTreeData() {
      this.treeData = []
      this.filesTable.files = []

      if(this.projectID === 0)
        return

      axios.get(`${baseApiUrl}/projetos/${this.projectID}/pastas`)
        .then( resp => { 
          for (const iterator of resp.data) {
            iterator.customData = iterator;
          }

          let _data = this.toTree(resp.data)
          this.$refs.fmTree.tree.setModel(_data)
        })
        .catch((e) => {console.log("getTreeDataError",e)
          showError(e)
        })
    },
    toTree(categories, tree) {
      if (!tree) tree = categories.filter(c => !c.pasta_id_pai);

      tree = tree.map(parentNode => {
        const isChild = node => node.pasta_id_pai == parentNode.pasta_id;
        parentNode.children = this.toTree(
          categories,
          categories.filter(isChild)
        );
        return parentNode;
      });
      return tree;
    },
    loadFiles(pastaID){
      this.filesTable.files = [];
      if(this.projectID === 0 || pastaID === 0)
        return
      this.filesTable.isBusy = true
      axios.get(`${baseApiUrl}/projetos/${this.projectID}/pastas/${pastaID}/arquivos`)
        .then(
          resp => {
            this.filesTable.isBusy = false
            this.filesTable.files = resp.data

          }
        )
        .catch(ex => {
          this.filesTable.isBusy = false
          showError(ex)
        })
    },
    onUnSelectFolder(){
      let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })  
      _folderSelected.unselect()
    },
    onNodeSelect(node) {
      this.loadFiles(node.data.pasta_id)
    },
    showRenameFolder(){
        this.newFolderName = ''
        let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })  
        if(_folderSelected.length == 0){
          this.$toasted.info("Selecione uma pasta!", {duration: 4000, keepOnHover: true, className: 'v-toasted-warning'});
          return
        }
        this.newFolderName = _folderSelected[0].data.nome
        this.$bvModal.show('modal-rename-folder')
    },
    renameFolder(){
      let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })
      let _pasta = {
        nome: this.newFolderName,
        projeto_id: this.projectID,
        pasta_id:  _folderSelected[0].data.pasta_id,
        pasta_id_pai: _folderSelected[0].data.pasta_id_pai
      }

      axios.put(`${baseApiUrl}/projetos/${this.projectID}/pastas/${_pasta.pasta_id}`, _pasta)
        .then(() => {
          this.getTreeData()
        })
        .catch(err => console.log(err))
      
      this.newFolderName = ''
      this.$bvModal.hide('modal-rename-folder');
    },
    deleteFolder(){
        let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })  
        if(_folderSelected.length == 0){
          this.$toasted.info("Selecione uma pasta!", {duration: 4000, keepOnHover: true, className: 'v-toasted-warning'});
          return
        }

        if(_folderSelected[0].children && _folderSelected[0].children.length > 0){
          this.$toasted.info("A pasta contém Sub Pastas. Elimine-as primeiro!", {duration: 4000, keepOnHover: true, className: 'v-toasted-warning'});
          return
        }

        axios.delete(`${baseApiUrl}/projetos/${this.projectID}/pastas/${_folderSelected[0].data.pasta_id}`)
          .then( () => this.getTreeData() )
          .catch( err => showError(err))
    },
    showNewFolder(){
        this.newFolderName = ''
        let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })  
        this.newFolderRoot = _folderSelected.length == 0
        this.rootForced = _folderSelected.length == 0
        this.$bvModal.show('modal-new-folder');
    },
    newFolder(){
      let _folderSelected = this.$refs.fmTree.findAll({state: { selected: true } })
      let _pasta = {
        nome: this.newFolderName,
        pasta_id_pai: this.newFolderRoot ? 0 : _folderSelected[0].data.pasta_id
      }

      axios.post(`${baseApiUrl}/projetos/${this.projectID}/pastas`, _pasta)
        .then(() => {
          this.getTreeData()
        })
        .catch(err => console.log(err))
      
      this.newFolderName = ''
      this.$bvModal.hide('modal-new-folder');
    },
  },
  mounted() {
    this.getTreeData()
    this.$refs.fmTree.$on("node:selected", this.onNodeSelect);
  }
};
</script>

<style scoped>
.file-manager {
  min-height: 200px;
  height: 100%;
  border: thin solid #dfe3e7;
  padding: 0;
  margin: 0;
}

.fm-toolbar {
  padding: 5px;
  background-color: #f8f9fa;
  border: thin solid #dfe3e7;
}

.fm-folder-bar{
  background-color: #f8f9fa;
  border: thin solid #dfe3e7;
}

.file-manager >>> .tree-node.selected > .tree-content {
  background-color: #007bff !important;
}

.file-manager >>> .tree-node.selected > .tree-anchor {
  color: #fff !important;
}

.folder-label {
  flex-grow: 1;
  cursor: pointer;
  margin-bottom: 0px;
}

.file-manager >>> .tree-node.selected > .tree-content > .tree-anchor {
  color: white !important;
}

.panel-files{
  display: flex;
  height: 100%;
}
</style>